<template>
  <div class="content">
    <el-row :gutter="12">
      <el-col :span="12" class="fix__top">
        <el-input
          class="style-fullWidth"
          v-model="filter.query"
          size="medium"
          placeholder="Tìm kiếm"
          prefix-icon="el-icon-search"
          @keydown.enter.exact.native="searchTree"
        ></el-input>
      </el-col>
    </el-row>

    <hashtag-common
      @selectTags="selectTags"
      @unSelectTags="unSelectTags"
      :groupTypeId="GROUPS.GROUP_TYPE_ID.DON_VI"
    />

    <VuePerfectScrollbar
      class="scroll-scope listCompanies"
      :settings="settings"
    >
      <el-tree
        v-loading="isLoadingRoots"
        ref="departmentTree"
        :data="roots"
        class="filter-tree"
        node-key="id"
        show-checkbox
        check-strictly
        :default-expanded-keys="setDefaultExpandedKeys"
        :filter-node-method="filterTree"
        @check-change="handleCheckChange"
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1 flex-row flex__between width__100" @click.native.stop="() => false">
          <span style="width: 350px">
            <span v-if="data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE">
              <span class="font-weight__bold">{{ data.userDeptRole.fullName }}</span>
              <span class="font-size__small font-italic">({{ data.userDeptRole.positionName }})</span>
              <span style="position: relative">
                <el-tooltip
                  v-if="data.userDeptRole.absentCount && data.userDeptRole.absentCount != 0"
                  :content="tooltipContent(data.userDeptRole)"
                  placement="right"
                  effect="dark"
                >
                  <absent-notify></absent-notify>
                </el-tooltip>
              </span>
            </span>
            <span style="white-space: pre-wrap" v-else>{{ getNodeLabel(data) }}</span>
          </span>
            <span
              class="padding-left-right-10"
              v-if="isShowProcessTypeRadio(node) && isVinataba"
            >
              <el-tag
                v-if="outgoingDoc.deptEditorId === node.data.department.id"
                :class="['priority', 'lv2']"
                size="mini"
              >
                Chủ trì
             </el-tag>
              <el-tag
                v-else
                :class="['priority', 'lv3']"
                size="mini"
              >
                Nhận để biết
             </el-tag>
          </span>
            <span
              class="padding-left-right-10"
              v-else-if="isShowProcessTypeRadio(node) && !isVinataba"
            >
              <el-radio-group v-model="processTypeRadio[data.userDeptRole ? data.userDeptRole.id : data.department.id]" @change="changeProcessType">
              <el-radio :label="PROCESS_TYPE_CHU_TRI">Chủ trì</el-radio>
              <el-radio :label="PROCESS_TYPE_PHOI_HOP">Phối hợp</el-radio>
              <el-radio :label="PROCESS_TYPE_NHAN_DE_BIET">Nhận để biết</el-radio>
            </el-radio-group>
            </span>
          </div>
        </div>
      </el-tree>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import constants from "../../../constants";
import utils from "../../../services/utils";
import h from "../../../services/h";
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import departmentService from "../../../services/departmentService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HashtagCommon from "../../doc-in/components/chuyenXuLy-hashtag";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";
import outgoingDocService from "../../../services/outgoingDocService";

export default {
  name: "banhanh-department-tree",
  mixins: [handlersTreeMixin],
  components: {
    AbsentNotify,
    HashtagCommon,
    VuePerfectScrollbar
  },
  props: ["docId", "selectedDepartmentIds", "selectedUserIds"],
  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      PROCESS_TYPE_CHU_TRI : constants.PROCESS_TYPE.CHUTRI,
      PROCESS_TYPE_PHOI_HOP : constants.PROCESS_TYPE.PHOIHOP,
      PROCESS_TYPE_NHAN_DE_BIET : constants.PROCESS_TYPE.NHANDEBIET,
      GROUPS: constants.GROUPS,
      filter: {
        query: null,
        showChecked: false
      },
      settings: {maxScrollbarLength: 750},
      selectedTagData: null,
      nextStepInfoViews: null,
      isLoadingRoots: true,
      processTypeRadio: {},
      defaultExpandedKeys: [],
      hashtagProcessTypeSelect: null,
      selectedHandlersData: [],
      outgoingDoc: {}
    };
  },

  created() {
    this.loadToDepartments().then(() => this.loadOutgoingDoc())
      .then(() =>
        Promise.all([this.loadHandlers(), this.loadNextStepInfoViews()])
      )
      .then(() => this.buildTree())
      // .then(() => this.initByDocReceivers())
    // chưa hiểu nguyên nhận tsao init phải đẩy vào trong buildTree
    // thì el-tree mới tick được checkbox mặc dù data đã set true
  },

  computed: {
    isVinataba(){
      return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA
    },

    isVinatabatrading() {
      return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABATRADING
    },

    deptName() {
      return this.$store.getters.userDeptRole.deptName;
    },

    setDefaultExpandedKeys(){
      if(this.deptName === 'Tổng công ty Thuốc lá Việt Nam')
        return ['vinataba-TCT'];
      else if(this.deptName === 'Đảng ủy Tổng công ty Thuốc lá Việt Nam') return ['493b975f-2b89-4a86-bb28-16b8993a9763']   ;
      else if(this.deptName === 'Đoàn Thanh niên Tổng công ty Thuốc lá Việt Nam') return  ['0ed02f77-8f13-49b9-872e-ec0508241d00'];
      else if (this.deptName === 'Công đoàn Tổng Công ty Thuốc lá Việt Nam') return ['7f47929e-bbd4-4c46-a141-3dfd29e17f4a'];
      else  return  [];
    },
  },

  methods: {
    buildTree() {
      this.buildNodes().then(() => {
        // Bỏ node ROOT
        this.roots = this.removeNodeROOT(this.roots);
        // this.isLoadingRoots = false;
      })
      .then(() => {
        //nếu đơn vị thực hiện là vinataba thì mặc định chọn đơn vị đó trước khi vào màn hình chọn
        if (this.isVinataba) {
          this.autoCheckChuTri()
        }
        this.initByDocReceivers()
        this.isLoadingRoots = false;
      });
    },

    autoCheckChuTri() {
      let chuTriNode;
      chuTriNode = this.$refs.departmentTree.getNode(this.outgoingDoc.deptEditorId);
      if (chuTriNode != null) {
        this.$refs.departmentTree.setChecked(chuTriNode.data, true);
      }
    },

    // remove ROOT node
    removeNodeROOT(root) {
      if (root.length > 0 && root[0].nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
        root[0].department.deptCode === constants.ROOT_DEPT_CODE) {
        const rootChildrenNode = root[0].children;
        if (this.isVinatabatrading) {
          root = rootChildrenNode;
        } else {
          root = rootChildrenNode.filter(item => item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && item.department.deptCode === this.$store.getters.globalRoles)
        }
      }
      return root;
    },

    handleCheckChange(data) {
        let key = data.userDeptRole ? data.userDeptRole.id : data.department.id;
        let processType;

        //nếu là đơn vị vinataba thì đơn vị thực hiện sẽ chủ trì, còn lại là nhận để biết
        if (this.isVinataba) {
          if (!data.userDeptRole) {
            if (data.department.id === this.outgoingDoc.deptEditorId) {
              processType = constants.PROCESS_TYPE.CHUTRI;
            } else {
              processType = constants.PROCESS_TYPE.NHANDEBIET;
            }
          }
        } else {
          processType = this.hashtagProcessTypeSelect !== null ? this.hashtagProcessTypeSelect : constants.PROCESS_TYPE.CHUTRI;
        }

      if (!(key in this.processTypeRadio)) {
        this.$set(this.processTypeRadio, key, processType);
      }
        if (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          this.addOrRemoveToSelectedHandlers(
            data,
            processType
          );
        }
      // }
    },

    // Set checked cho children
    setCheckedForChildren(data, isChecked) {
      if (isChecked) {
        const node = this.$refs.departmentTree.getNode(data);
        this.$set(node, 'expanded', isChecked)

        for (const children of data.children) {
          this.$refs.departmentTree.setChecked(children, isChecked);
          this.handleCheckChange(children)
        }
      } else {
        let isCheckedAllChildren = true;
        for (const children of data.children) {
          const childNode = this.$refs.departmentTree.getNode(children);
          if (childNode.checked === false) {
            isCheckedAllChildren = false;
            break;
          }
        }
        if (isCheckedAllChildren) {
          for (const children of data.children) {
            this.$refs.departmentTree.setChecked(children, isChecked);
          }
        }
      }
    },

    addOrRemoveToSelectedHandlers(data, processType) {
      const node = this.$refs.departmentTree.getNode(data);
      let checked = node.checked;
      let index = h.indexOf(this.selectedHandlersData, item => item.data === data);
      if (checked) {
        if (index === -1) {
          this.selectedHandlersData.push({
            data: data,
            processType: processType
          });
        }
      } else {
        const key = data.userDeptRole ? data.userDeptRole.id : data.department.id;
        this.$delete(this.processTypeRadio, key);
        this.selectedHandlersData.splice(index, 1);
      }
    },

    changeProcessType() {
      for (let i = 0; i < this.selectedHandlersData.length; i++) {
        const item = this.selectedHandlersData[i];
        if (item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          if(item.data.userDeptRole.id in this.processTypeRadio) {
            item.data.processType = this.processTypeRadio[item.data.userDeptRole.id]
            item.processType = this.processTypeRadio[item.data.userDeptRole.id]
          }
        } else {
          if(item.data.department.id in this.processTypeRadio) {
            item.data.processType = this.processTypeRadio[item.data.department.id]
            item.processType = this.processTypeRadio[item.data.department.id]
          }
        }
      }
    },

    getSelectedHandlersData() {
      return this.selectedHandlersData;
    },

    tooltipContent(item){
      return `Vắng mặt từ `+dateFormatter(item.absentStartTime)+` đến `+dateFormatter(item.absentDeadlineTime);
    },
    getToDepartments() {
      let toDepartments = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
          data.checked
        )
          toDepartments.push(data.department);
        queue.push(...(data.children || []));
        index++;
      }
      return toDepartments;
    },

    getToHandlers() {
      let toHandlers = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType ===
          constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
          data.checked
        )
          toHandlers.push(data.userDeptRole);
        queue.push(...(data.children || []));
        index++;
      }
      return toHandlers;
    },

    getHandlersStepInfo(handlersData) {
      return h.collect(handlersData, userDeptRole => {
        let nextStepInfoView = h.find(this.nextStepInfoViews, nextStepInfoView_ =>
          nextStepInfoViewService.isMatchingWithUserDeptRole(userDeptRole, nextStepInfoView_)
        );
        let handler = {...userDeptRole};
        if (nextStepInfoView) {
          handler.vbStepInfoId = nextStepInfoView.vbStepInfoId;
          handler.stepId = nextStepInfoView.id;
          handler.flowId = nextStepInfoView.flowId;
        }
        return handler;
      })
    },

    loadToDepartments() {
      return departmentService
        .findAllForBanHanh(this.docId)
        .then(response => (this.departmentHandlers = response.data));
    },

    loadOutgoingDoc() {
      return outgoingDocService.findById(this.docId).then(response => {
        this.outgoingDoc = response.data;
      });
    },

    loadHandlers() {
      return userDeptRoleViewService
        .findAllForBanHanh(this.docId)
        .then(response => (this.userDeptRoleHandlers = response.data));
    },

    loadNextStepInfoViews() {
      return nextStepInfoViewService
        .findAllForBanHanh(this.docId)
        .then(response => (this.nextStepInfoViews = response.data));
    },

    initByDocReceivers() {
      if(this.selectedDepartmentIds && this.selectedDepartmentIds.length)  this.getSelectFromDialog(this.selectedDepartmentIds);
      if(this.selectedUserIds && this.selectedUserIds.length) this.getSelectFromDialog(this.selectedUserIds);
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.filter);
    },

    getSelectFromDialog(event) {
      for (const item of event) {
        let node;
          if(item.id) node = this.$refs.departmentTree.getNode(item.id);
        if (node) {
          this.$set(this.processTypeRadio, item.id, item.processType);
          this.$refs.departmentTree.setChecked(node.data, true);
        }
      }
    },

    selectTags(event, hashtagProcessTypeSelect) {
      this.hashtagProcessTypeSelect = hashtagProcessTypeSelect;
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.departmentTree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.departmentTree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.departmentTree.setChecked(node.data, true);
          this.handleCheckChange(node.data);
          // this.refreshNodeExpand();
        }
      }
    },

    unSelectTags(event) {
      this.hashtagProcessTypeSelect = null;
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.departmentTree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.departmentTree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.departmentTree.setChecked(node.data, false);
        }
      }
    },

    filterTree(value, data, node) {
      if (!value.query && !value.showChecked) {
        return true;
      }

      let b = true;
      if (value.query) {
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            b = utils.like(data.department.deptName, value.query);
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            const nodeLabel = `${data.userDeptRole.fullName} (${data.userDeptRole.positionName})`
            b = utils.like(nodeLabel, value.query);
            break;
          default:
            b = utils.like(utils.getNodeLabelForHandlersTree(data), value.query);
            break;
        }
      }

      if (value.showChecked) {
        b = b && node.checked === value.showChecked
      }

      return b;
    },

    getNodeLabel(node) {
      return utils.getNodeLabel(node);
    },

    isShowProcessTypeRadio(node) {
      return node.checked;
    },

    checkedAll(data, checked) {
      this.checkedAllChildren(data, checked);
      this.updateCheckedForParent(data);
    },

    checkedChange(data) {
      this.updateCheckedForParent(data);
    }
  }
};
</script>
<style>
.el-tree-node__content {
  margin: 4px 0;
}
.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 500px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-department-tree.vue